import { useState } from "react";

import {
  AtsIntegration,
  IcimsIntegrationContext,
} from "./IcimsIntegrationContext";
import { IcimsSetupStep } from "./components/steps/IcimsSetupStep";

function generateIcimsUsernamePassword() {
  return crypto.randomUUID();
}

export function IcimsIntegrationSetupPage() {
  const [atsIntegrationData, setAtsIntegration] = useState<AtsIntegration>({
    customer_id: "",
    icims_username: "",
    icims_password: "",
    icims_webhook_username: generateIcimsUsernamePassword(),
    icims_webhook_password: generateIcimsUsernamePassword(),
    customer_group_id: "",
    report_url_type: "DIRECT_PDF_URL",
  });

  return (
    <IcimsIntegrationContext.Provider
      value={{
        atsIntegrationData,
        setAtsIntegration,
      }}
    >
      <IcimsSetupStep />
    </IcimsIntegrationContext.Provider>
  );
}
